import { useState } from "react"


export default function FormDropdown({id, label, options, action, defOption, hasInfo=false, infoContent=null}) {
    const [showInfo, setShowInfo] = useState(false);
    const deployOptions=()=>{
        return options.map((opt, inx)=>{
            return <option key={`formDropDown_option_${inx}`} value={opt}>{opt}</option>
        })
    }
    return (
        <div className='formDropdown'>
            <div className="form_infoDiv">
                {hasInfo ? <div className="form_info" onMouseEnter={()=>{setShowInfo(true)}} onMouseLeave={()=>{setShowInfo(false)}}>
                    ?
                    {showInfo ? <div className="form_infoContent">{infoContent}</div> : null}
                </div> : null}
            </div>
            <label htmlFor={id}>{label}</label>
            <select id={id} onChange={action} defaultValue={defOption}>
                <option hidden disabled value={defOption}>בחר {defOption}...</option>
                {deployOptions()}
            </select>
        </div>
    )
}
